import {
  Aggregate,
  AggregateColumnDirective,
  AggregateColumnsDirective,
  AggregateDirective,
  AggregatesDirective,
  ColumnChooser,
  ColumnDirective,
  ColumnMenu,
  ColumnsDirective,
  ContextMenu,
  Edit,
  EditSettingsModel,
  ExcelExport,
  Filter,
  FilterSettingsModel,
  GridComponent,
  Group,
  Inject,
  Page,
  PageSettingsModel,
  PdfExport,
  Reorder,
  Resize,
  Sort,
  Toolbar,
  ToolbarItems,
} from '@syncfusion/ej2-react-grids';
import { GetBackendUrlForGlobalFunctions } from '../App';
import axios, { AxiosResponse } from 'axios';
import { useEffect, useState } from 'react';
import { all_information, loadingShow } from '../App';
import Message from '../utils/Message/Message';
import './GlobalGrid.css';
import { getFethSize } from '../services/SystemSettings/SystemSettingsService';
import {
  getLocalUtcOffSetValue,
  isInlineEditOrderDataEqual,
} from '../utils/Methods/methods';
import { useDispatch, useSelector } from 'react-redux';
import { setFetchSize } from '../redux/search.slice';
import { EditWorkOrder } from '../services/CloudScheduler/CloudSchedulerServices';
import { UndoRedo } from '@syncfusion/ej2-react-gantt';
let isAdd: boolean = false;
let isRenderFinish: boolean = false;

var thePrimaryFieldName = 'id';
const headers = {
  'Content-Type': 'application/json',
};
interface IProps {
  undo?: boolean;
  children?: React.ReactNode;
  query: string;
  columns: Array<any>;
  height: string;
  signalOfLoad: boolean;
  toolbarOptions?: ToolbarItems[];
  toolbarClickItems?: Function;
  add_query?: string;
  edit_query?: string;
  delete_query?: string;
  get_query?: string;
  id?: string;
  isFitInCOntent?: boolean;
  rowSelected?: Function;
  rowDeselected?: Function;
  enableAggregate?: boolean;
  aggregateColumns?: Array<any>;
  groupSettings?: Object;
  enablePagination?: boolean;
  contextMenuItems?: Array<any>;
  contextMenuClick?: (args: any) => void;
  gridRef?: (component: GridComponent) => void;
  allowCheckBox?: boolean;
  allowMultiSelection?: boolean;
  resetSignal?: string;
  noNeedPagination?: boolean;
  additionalCrudParams?: Object;
  refreshRequest?: string;
  primaryKeyName?: string;
  additinalToolbarClick?: (args: any) => void;
  queryCellInfo?: (args: any) => void;
  theEditOptions?: EditSettingsModel;
  mapFieldToType?: Array<any>;
  toolbarTemplate?: any;
  avoidWhereClause?: boolean;
  refreshRequestHandle?: () => void | undefined;
  fromComponent?: string;
  rowDataBound?: (args: any) => void;
}

var model: any = [];
var theGrid: GridComponent;
const GlobalGrid = ({
  undo,
  fromComponent,
  columns,
  query,
  toolbarOptions,
  height,
  add_query,
  delete_query,
  edit_query,
  get_query,
  id,
  isFitInCOntent,
  rowSelected,
  rowDeselected,
  aggregateColumns,
  enableAggregate,
  groupSettings,
  enablePagination,
  signalOfLoad,
  contextMenuClick,
  contextMenuItems,
  gridRef,
  allowCheckBox,
  allowMultiSelection,
  resetSignal,
  noNeedPagination,
  additionalCrudParams,
  toolbarClickItems,
  refreshRequest,
  primaryKeyName,
  additinalToolbarClick,
  queryCellInfo,
  theEditOptions,
  mapFieldToType,
  toolbarTemplate,
  avoidWhereClause,
  refreshRequestHandle,
  rowDataBound,
}: IProps) => {
  let timezone_offset = useSelector(
    (state: any) => state.search.timezone_offset
  );
  let thePlanID = Number(localStorage.getItem('cs_plan_dd_value'));
  const ERP_TYPE = process.env.REACT_APP_ERP_TYPE;
  const dispatch = useDispatch();
  //const context = useContext(ThemeContext);
  const [datasource, setDatasource] = useState<any>();
  const FilterOptions: FilterSettingsModel = { type: 'Excel' };
  const tz: string = Intl.DateTimeFormat().resolvedOptions().timeZone;
  const [timezoneName, setTimezoneName] = useState<string>(tz);
  let global_fetch_size = useSelector(
    (state: any) => state.search.page_range_from_settings
  );
  let InlineEditedList: any[] = [];
  const serverOffsetMillis = 60 * 1000 * -600;
  const localOffset = new Date().getTimezoneOffset();
  const localOffsetMillis = 60 * 1000 * localOffset;

  let page_range_from_settings = global_fetch_size;
  //var current_page_range = '1$150';
  var current_page_range = `1$${page_range_from_settings}`;
  //var current_page: number = 150 / 50;
  var current_page: number = page_range_from_settings / 50;

  var moment = require('moment-timezone');
  const [renderamount, setrenderamount] = useState(0);
  const editOptions: EditSettingsModel = {
    allowAdding: true,
    allowDeleting: true,
    allowEditing: true,
    showDeleteConfirmDialog: true,
  };
  const pageOptions: PageSettingsModel = {
    currentPage: 1,
    pageSize: 50,
    pageCount: 8,
    pageSizes: false,
  };
  const toolbarClick = (args: any) => {
    if (additinalToolbarClick) {
      additinalToolbarClick(args);
    }
    if (args.item.id === 'refresh') {
      model = [];
      getData(query, model, theGrid);
    }
    if (args.item.id === id + '_excelexport') {
      theGrid.excelExport();
    }
    if (args.item.id === id + '_pdfexport') {
      theGrid.pdfExport();
    }
  };
  const actionComplete = (args: any) => {
    if (args.requestType == 'batchsave') {
      if (ERP_TYPE === 'MEX') {
        const differenceOffsetMillis = serverOffsetMillis - localOffsetMillis;

        InlineEditedList.map((item: any) => {
          item.scheduled_start_date = new Date(
            new Date(item.scheduled_start_date)?.getTime() +
              differenceOffsetMillis
          ).toString();
          item.scheduled_end_date = new Date(
            new Date(item.scheduled_end_date)?.getTime() +
              differenceOffsetMillis
          ).toString();
        });
      }
      try {
        EditWorkOrder(InlineEditedList, timezone_offset).then(() => {
          Message.success('Edited');
        });
      } catch (error) {
        console.log(error);
      }

      // InlineEditedList.map(async (each) => {
      //   await addPoint(each);
      // });
    }
  };
  const actionBegin = (args: any) => {
    if (args.action === 'add') {
      isAdd = true;
      if (add_query) {
        args.data.crud_type = 'add';
        if (fromComponent === 'operation-template-detail') {
          delete args.data.crud_type;
          args.data.ID = thePlanID;
        }
        addPoint(args.data);
      }
    } else if (args.action === 'edit') {
      if (args.data.est_hours && args.data.required) {
        args.data.duration = (
          parseInt(args.data.est_hours) / parseInt(args.data.required)
        )
          .toFixed(2)
          .toString();
      }
      isAdd = false;
      if (edit_query) {
        //args.data.crud_type = 'edit';
        if (
          !isInlineEditOrderDataEqual(args.data, args.previousData) ||
          id === 'operation-template-detail'
        ) {
          delete args.data.materialStatus;
          addPoint(args.data);
        }
      }
    } else if (args.requestType === 'delete') {
      var theKeyName = theGrid.getPrimaryKeyFieldNames();
      id = args.data[0][`${theKeyName[0]}`];
      if (!id) {
        if (!primaryKeyName) {
          Message.error('Primary key not found to procced');
          return;
        } else {
          id = args.data[0][`${primaryKeyName}`];
          thePrimaryFieldName = primaryKeyName;
        }
      } else {
        thePrimaryFieldName = theKeyName[0];
      }
      if (delete_query) {
        args.data.crud_type = 'delete';
        deletePoint();
      }
    }
    if (args.requestType === 'paging') {
      var pS: any;
      if (args.currentPage > args.previousPage) {
        if (args.currentPage >= current_page) {
          current_page++;
          pS = theGrid.pageSettings.pageSize;
          var start_index = (current_page - 1) * Number(pS) + 1;
          var end_index = start_index + (Number(pS) - 1);
          current_page_range = start_index + '$' + end_index;
          getData(query, model, theGrid);
        }
      } else if (args.currentPage === args.previousPage) {
        pS = theGrid.pageSettings.pageSize;
        var last_page = model.length / Number(pS);
        current_page = last_page;
      }
    }
  };
  const deletePoint = () => {
    const obj = {
      [thePrimaryFieldName]: id,
    };
    let theUrl = GetBackendUrlForGlobalFunctions() + `${delete_query}`;
    axios
      .put(theUrl, obj, {
        headers,
      })
      .then((res) => {
        loadingShow(false);
        Message.success('Successfully');
        model = [];
        getData(query, model, theGrid);
      })
      .catch((err) => {
        loadingShow(false);
        if (err.response) {
          Message.error(
            err.response.data +
              '\n' +
              err.response.status +
              '\n' +
              err.response.headers
          );
        } else if (err.request) {
          Message.error(err.request);
        } else {
          Message.error('Error: ' + err.message);
        }
      });
  };
  function extractNumberFromString(s: string): number {
    let matches: RegExpMatchArray | null = s.match(/\d+/g);
    return matches ? Number(matches.join('')) : NaN;
  }
  const getData = async (query: string, theModel: any, grid: GridComponent) => {
    let theQuery = '';

    if (!noNeedPagination) {
      theQuery = current_page_range + '$' + query.trim().trimStart().trimEnd();
    } else {
      theQuery = query.trim();
    }
    let theUrl = '';

    if (get_query === 'order') {
      if (avoidWhereClause) {
        theUrl =
          GetBackendUrlForGlobalFunctions() +
          `${get_query}` +
          `/${timezone_offset}?` +
          theQuery;
      } else {
        theUrl =
          GetBackendUrlForGlobalFunctions() +
          `${get_query}` +
          `/${timezone_offset}?where=` +
          theQuery;
      }
    } else {
      if (get_query === 'mex-order') {
        theQuery = '';
        theQuery = '/changes';
        theUrl = GetBackendUrlForGlobalFunctions() + `${get_query}` + theQuery;
      } else {
        if (avoidWhereClause) {
          theUrl =
            GetBackendUrlForGlobalFunctions() + `${get_query}?` + theQuery;
        } else {
          theUrl =
            GetBackendUrlForGlobalFunctions() +
            `${get_query}` +
            `?where=` +
            theQuery;
        }
      }
    }

    const arr: any = [
      { id: '0', location: 'Africa/Abidjan', GMT: 'GMT + 0' },
      { id: '1', location: 'Africa/Algiers', GMT: 'GMT + 1' },
      { id: '2', location: 'Africa/Johannesburg', GMT: 'GMT + 2' },
      { id: '3', location: 'Indian/Antananarivo', GMT: 'GMT + 3' },
      { id: '4', location: 'Asia/Baku', GMT: 'GMT + 4' },
      { id: '5', location: 'Asia/Ashkhabad', GMT: 'GMT + 5' },
      { id: '6', location: 'Asia/Bishkek', GMT: 'GMT + 6' },
      { id: '7', location: 'Asia/Bangkok', GMT: 'GMT + 7' },
      { id: '8', location: 'Asia/Brunei', GMT: 'GMT + 8' },
      { id: '5.3', location: 'Etc/GMT+5:30', GMT: 'GMT + 5: 30' },
      { id: '9', location: 'Asia/Tokyo', GMT: 'GMT + 9' },
      { id: '10', location: 'Asia/Vladivostok', GMT: 'GMT + 10' },
      { id: '11', location: 'Asia/Sakhalin', GMT: 'GMT + 11' },
      { id: '12', location: 'Pacific/Fiji', GMT: 'GMT + 12' },
      { id: '13', location: 'Pacific/Tongatapu', GMT: 'GMT + 13' },
      { id: '14', location: 'Pacific/Kiritimati', GMT: 'GMT + 14' },
      { id: '-12', location: 'Etc/GMT+12', GMT: 'GMT - 12' },
      { id: '-11', location: 'Pacific/Midway', GMT: 'GMT - 11' },
      { id: '-10', location: 'Etc/GMT+10', GMT: 'GMT - 10' },
      { id: '-9', location: 'Pacific/Gambier', GMT: 'GMT - 9' },
      { id: '-8', location: 'Pacific/Pitcairn', GMT: 'GMT - 8' },
      { id: '-7', location: 'America/Creston', GMT: 'GMT - 7' },
      { id: '-6', location: 'America/Denver', GMT: 'GMT - 6' },
      { id: '-5', location: 'America/Eirunepe', GMT: 'GMT - 5' },
      { id: '-4', location: 'America/Grenada', GMT: 'GMT - 4' },
      { id: '-3', location: 'America/Halifax', GMT: 'GMT - 3' },
      { id: '-2', location: 'America/Miquelon', GMT: 'GMT - 2' },
      { id: '-1', location: 'Etc/GMT+1', GMT: 'GMT - 1' },
    ];
    const timezone = getLocalUtcOffSetValue() / 60;
    const localOffset = new Date().getTimezoneOffset();
    const localOffsetMillis = 60 * 1000 * localOffset;
    let theResult: AxiosResponse<any>;
    try {
      theResult = await axios.get(theUrl);
      if (isRenderFinish) {
        theResult.data.map((res: any) => {
          for (var i = 0; i < Object.keys(res).length; i++) {
            let f_name = Object.keys(res)[i];

            if (
              f_name === 'plan_id' &&
              res.plan_id === extractNumberFromString(query)
            ) {
              res.isChecked = true;
            }
            if (
              f_name === 'actual_start_date' &&
              res.actual_start_date === null
            ) {
              delete res.actual_start_date;
            }
            if (f_name === 'actual_end_date' && res.actual_end_date === null) {
              delete res.actual_end_date;
            }

            if (f_name.endsWith('date')) {
              const dateRegex = /\b\w+date\b/gi; // Son harfi "date" olan ifadeleri bulan regex
              const dateString = f_name.match(dateRegex) || [];

              if (dateString) {
                if (typeof timezone === 'number') {
                  arr.map((item: any) => {
                    if (-timezone === Number(item?.id)) {
                      setTimezoneName(item?.location);
                    }
                  });
                } else {
                  setTimezoneName(moment.tz.guess());
                }
                if (ERP_TYPE === 'MEX') {
                  res[f_name] = moment
                    .utc(res[f_name])
                    .tz(timezoneName)
                    .format('YYYY-MM-DD HH:mm:ss');
                  res[f_name] = new Date(res[f_name]);
                } else {
                  res[f_name] = new Date(res[f_name]).toUTCString();
                  res[f_name] = new Date(res[f_name]);
                }
              }
            }

            if (typeof res[f_name] === 'string') {
              res[f_name] = res[f_name]?.trim();
            }
            if (get_query === 'order') {
              const startDate = new Date(res.scheduled_start_date);
              const endDate = new Date(res.scheduled_end_date);

              let difference = endDate.getTime() - startDate.getTime();

              res.duration = difference / (1000 * 3600);
            }
          }
          theModel.push({
            ...res,
          });
        });
        if (isRenderFinish) {
          if (grid && grid !== null) {
            // grid.dataSource = theModel;
            // grid?.refresh();
            setDatasource([]);
            setDatasource(theModel);
            grid?.refresh();
          }
        }
      }
    } catch (error) {
      Message.error('Error while fetching data');
    }
    loadingShow(false);
  };
  const addPoint = async (objCommer: any) => {
    loadingShow(true, 'Adding');
    if (objCommer.id === undefined && objCommer.id === null) {
      objCommer.id = 0;
    }
    let theMappings: any = {};
    if (mapFieldToType) {
      mapFieldToType.map((el) => {
        if (objCommer[el.field]) {
          if (el.type === 'string') {
            theMappings[el.field] = objCommer[el.field].toString();
          }
          if (el.type === 'number') {
            theMappings[el.field] = Number(objCommer[el.field]);
          }
        }
      });
    }
    const obj = {
      ...objCommer,
      app: 'UWORK',
      created_by: all_information.user_id,
      organization_id: all_information.company_id?.toString(),
      ...additionalCrudParams,
      ...theMappings,
    };
    delete obj.creation_date;
    delete obj.rowstamp;
    if (isAdd) {
      let theUrl = GetBackendUrlForGlobalFunctions() + `${add_query}`;
      delete obj.id;
      axios
        .put(theUrl, obj, {
          headers,
        })
        .then((res) => {
          loadingShow(false);
          Message.success('Successfully');
          model = [];
          getData(query, model, theGrid);
        })
        .catch((err) => {
          loadingShow(false);
          if (err.response) {
            Message.error(err.response.data);
            Message.error(err.response.status);
            Message.error(err.response.headers);
          } else if (err.request) {
            Message.error(err.request);
          } else {
            Message.error('Error: ' + err.message);
          }
        });
    } else {
      if (ERP_TYPE === 'PRONTO') {
        timezone_offset = 0;
      }
      let theUrl =
        GetBackendUrlForGlobalFunctions() +
        `${edit_query}` +
        `/${timezone_offset}`;

      if (id === 'operation-template-detail') {
        theUrl = GetBackendUrlForGlobalFunctions() + `${edit_query}`;
      }
      if (ERP_TYPE === 'MEX') {
        const serverOffsetMillis = 60 * 1000 * -600;

        const localOffset = new Date().getTimezoneOffset();
        const localOffsetMillis = 60 * 1000 * localOffset;

        const differenceOffsetMillis = serverOffsetMillis - localOffsetMillis;
        obj.scheduled_start_date = new Date(
          new Date(obj.scheduled_start_date)?.getTime() + differenceOffsetMillis
        ).toString();
        obj.scheduled_end_date = new Date(
          new Date(obj.scheduled_end_date)?.getTime() + differenceOffsetMillis
        ).toString();
      }
      axios
        .put(theUrl, obj, {
          headers,
        })
        .then((res) => {
          loadingShow(false);
          Message.success('Successfully');
          model = [];
          getData(query, model, theGrid);
        })
        .catch((err) => {
          loadingShow(false);
          if (err.response) {
            Message.error(err.response.data);
            Message.error(err.response.status);
            Message.error(err.response.headers);
          } else if (err.request) {
            Message.error(err.request);
          } else {
            Message.error('Error: ' + err.message);
          }
        });
    }
  };
  const onGridCreated = () => {
    if (gridRef) {
      gridRef(theGrid);
    }
  };

  useEffect(() => {
    const getFetchSize = async () => {
      const model = await getFethSize();

      model.data.map((item: any) => {
        if (item.isChecked === true) {
          page_range_from_settings = item.fetch_size;
        }
      });
      dispatch(setFetchSize(page_range_from_settings));
      return (current_page_range = '1$' + page_range_from_settings?.toString());
    };
    getFetchSize();
  }, [global_fetch_size]);

  useEffect(() => {
    if (model.length > 0) {
      setDatasource(undefined);
    }
  }, [resetSignal]);

  useEffect(() => {
    model = [];
    const getTheData = async () => {
      theGrid.showSpinner();
      await getData(query, model, theGrid);
    };
    if (renderamount != 0) {
      getTheData();
    }
    theGrid.dataSource = datasource;
    setrenderamount(renderamount + 1);
  }, [timezone_offset, timezoneName]);

  useEffect(() => {
    if (
      refreshRequest &&
      refreshRequest !== '' &&
      refreshRequest?.trim() !== 'false'
    ) {
      current_page_range = 1 + '$' + current_page * 50;
      if (signalOfLoad) {
        model = [];
        const getTheData = async () => {
          await getData(query, model, theGrid);
        };
        getTheData();
        signalOfLoad = false;
        refreshRequest = 'false';
        refreshRequestHandle ? refreshRequestHandle() : <></>;
      }
    }
  }, [refreshRequest]);

  useEffect(() => {
    isRenderFinish = true;
    if (get_query) {
      model = [];
      //current_page_range =current_page_range;
      current_page = 3;
      if (signalOfLoad) {
        loadingShow(true, 'Process will take some time, please wait...');
        const getTheData = async () => {
          await getData(query, model, theGrid);
        };
        getTheData();
      }
    }
    return () => {
      isRenderFinish = false;
    };
  }, [query]);
  const undoRedoActions: any = [
    'Sorting',
    'Add',
    'ColumnReorder',
    'ColumnResize',
    'ColumnState',
    'Delete',
    'Edit',
    'Filtering',
    'Indent',
    'Outdent',
    'NextTimeSpan',
    'PreviousTimeSpan',
    'RowDragAndDrop',
    'Search',
  ];
  return (
    <div className={id}>
      <GridComponent
        actionComplete={actionComplete.bind(this)}
        rowDataBound={rowDataBound}
        cellSaved={(args) => {
          if (!(args.value == args.previousValue)) {
            let data = args.rowData;
            data[args.column.field] = args.value;
            InlineEditedList.push(data);
          }
        }}
        id={id + '-grid'}
        ref={(refGrid: GridComponent) => {
          theGrid = refGrid;
        }}
        editSettings={theEditOptions ? theEditOptions : editOptions}
        toolbar={signalOfLoad ? toolbarOptions : undefined}
        dataSource={datasource}
        dataSourceChanged={() => {
          theGrid.refresh();
        }}
        height={height}
        width={'100%'}
        pageSettings={pageOptions}
        filterSettings={FilterOptions}
        allowFiltering={true}
        allowPaging={true}
        showColumnMenu={true}
        allowResizing={true}
        allowExcelExport={true}
        allowPdfExport={true}
        allowSorting={true}
        allowReordering={true}
        toolbarTemplate={toolbarTemplate}
        groupSettings={groupSettings}
        showColumnChooser={true}
        allowGrouping={true}
        queryCellInfo={queryCellInfo}
        dataBound={() => {
          if (isFitInCOntent) {
            theGrid.autoFitColumns(theGrid.getColumnFieldNames());
          }
        }}
        toolbarClick={
          toolbarClickItems
            ? toolbarClickItems.bind(this)
            : toolbarClick.bind(this)
        }
        actionBegin={actionBegin.bind(this)}
        gridLines='Both'
        rowSelected={rowSelected?.bind(this)}
        rowDeselected={rowDeselected?.bind(this)}
        contextMenuItems={contextMenuItems}
        contextMenuClick={contextMenuClick}
        created={onGridCreated}
        selectionSettings={{
          type: allowMultiSelection ? 'Multiple' : 'Single',
          persistSelection: true,
        }}
        allowSelection={true}
      >
        <ColumnsDirective>
          {allowCheckBox ? (
            <ColumnDirective
              headerText='#'
              allowEditing={false}
              displayAsCheckBox={true}
              type='checkbox'
              width={40}
            />
          ) : null}
          {columns.map((el) => {
            return (
              <ColumnDirective
                field={el.field}
                headerText={el.headerText?.replaceAll('_', ' ')}
                textAlign='Left'
                validationRules={el.validationRule}
                template={el.template}
                isPrimaryKey={el.isPrimaryKey}
                width={el.width}
                editType={el.editType}
                allowEditing={el.allowEditing}
                editTemplate={el.editTemplate}
                format={el.format}
                key={el.field}
                visible={el.visible}
                clipMode={el.clipMode}
                type={el.type}
                edit={el.edit}
              />
            );
          })}
        </ColumnsDirective>
        {enableAggregate ? (
          <AggregatesDirective>
            <AggregateDirective>
              <AggregateColumnsDirective>
                {aggregateColumns?.map((col) => {
                  return (
                    <AggregateColumnDirective
                      field={col.field}
                      type='Sum'
                      format='C2'
                      key={col.field}
                    />
                  );
                })}
              </AggregateColumnsDirective>
            </AggregateDirective>
          </AggregatesDirective>
        ) : null}
        <Inject
          services={[
            Edit,
            Toolbar,
            Filter,
            Page,
            ColumnChooser,
            ExcelExport,
            PdfExport,
            ColumnMenu,
            Resize,
            Sort,
            Group,
            Reorder,
            Aggregate,
            ContextMenu,
            ...(undo ? [UndoRedo] : []),
          ]}
        />
      </GridComponent>
    </div>
  );
};

export default GlobalGrid;
